import { render, staticRenderFns } from "./TabellaTempiSquadra.vue?vue&type=template&id=740b30ba&"
import script from "./TabellaTempiSquadra.vue?vue&type=script&lang=js&"
export * from "./TabellaTempiSquadra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports